export default __webpack_public_path__ + "static/media/bloodbath3.27957a1f.png";